const CardItem = function ({url}) {
  return (
    <div
      style={{
        height: "240px",
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "264px",
          height: "240px",
          left: "0px",
          top: "0px",
          background: "rgb(242, 169, 0)",
          borderRadius: "0px 24px",
        }}
      >
        <img
          src={url}
          style={{
            position: "absolute",
            height: "192px",
            width: "304px",
            objectFit: "cover",
            left: "24px",
            top: "24px",
            filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px 8px 24px)",
            borderRadius: "12px",
          }}
        />
      </div>
    </div>
  );
};

export default CardItem;
